import "./PostulacionFormikInputWraper.scss";

const PostulacionFormikInputWraper = ({spanText, children, allSpace}) => {
  return (
		<div className={`postulacionFormikInputWraper--container ${allSpace && "all-space"}`}>
			<span className="body-14 c-black">{spanText + ":"}</span>
      {children}
		</div>
	);
}

export default PostulacionFormikInputWraper
